import Vue from 'vue'
import VueRouter from 'vue-router'
import Source from '../views/Source.vue'
import PipelineReports from '../views/PipelineReport.vue'
import LeadAgeingReport from '../views/LeadAgeingReport/LeadAgeingReport.vue'
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Source-Wise',
    component: Source
  },
  {
    path: '/subsource',
    name: 'SubSource-Wise',
    component: () => import(/* webpackChunkName: "about" */ '../views/SubSource.vue')
  },
  {
    path: '/marketingactivation',
    name: 'MarketingActivation',
    component: () => import(/* webpackChunkName: "about" */ '../views/MarketingActivation/MarketingActivationReport.vue')
  },
  {
    path: '/marketingactivationdetail',
    name: 'MarketingActivationDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/MarketingActivation/MarketingActivationDetail.vue')
  },
  {
    path: '/mastercpl/for/:itemType/:itemId',
    name: 'MasterCpl',
    component: () => import(/* webpackChunkName: "about" */ '../views/MarketingActivation/MasterCpl.vue')
  },
  {
    path: '/callactivity',
    name: 'Call-Activity',
    component: () => import(/* webpackChunkName: "about" */ '../views/CallActivityReport.vue')
  },
  {
    path: '/backlog',
    name: 'Backlog',
    component: () => import(/* webpackChunkName: "about" */ '../views/BacklogReport.vue')
  },
  {
    path: '/userroi',
    name: 'UserRoi',
    component: () => import(/* webpackChunkName: "about" */ '../views/UserRoiReport.vue')
  },
  {
    path: '/sourceroi',
    name: 'SourceRoi',
    component: () => import(/* webpackChunkName: "about" */ '../views/SourcewiseRoiReport.vue')
  },
  {
    path: '/projectroi',
    name: 'ProjectRoi',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProjectwiseRoiReport.vue')
  },
  {
    path: '/qualification',
    name: 'Qualification',
    component: () => import(/* webpackChunkName: "about" */ '../views/Qualification.vue')
  },
  {
    path: '/allreports',
    name: 'AllReports',
    component: () => import(/* webpackChunkName: "about" */ '../views/AllReports.vue')
  },
  {
    path: '/user',
    name: 'User-Wise',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Users.vue')
  },
  {
    path: '/enquiry',
    name: 'Enquiry-Wise',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Enquiry.vue')
  },
  {
    path: '/more',
    name: 'More',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/More.vue')
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/details',
    name: 'Details',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Details.vue')
  },
  {
    path: '/statusdetails',
    name: 'StatusDetails',
    component: () => import(/* webpackChunkName: "about" */ '../views/StatusDetails.vue')
  },
  {
    path: '/projectwiseroidetail',
    name: 'ProjectwiseRoiDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProjectwiseRoiDetail.vue')
  },
  {
    path: '/leads/for/:itemType/:itemId/status/:statusId/from/:fromDate/upto/:toDate',
    name: 'Leads-List',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/LeadsList.vue')
  },
  {
    path: '/leads/for/:itemType/:itemId',
    name: 'All-Leads-List',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AllLeadList.vue')
  },
  {
    path: '/leads/for/:itemType/:itemId/status/:statusId/sub_status/:subStatusId/from/:fromDate/upto/:toDate',
    name: 'Leads-List',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/LeadsList.vue')
  },
    {
    path: '/leads/for/:itemType/:userid/projects/:projectid',
    name: 'ageing-Leads-List',
    component: () => import(/* webpackChunkName: "about" */ '../views/AllLeadList.vue')
  },
  {
    path: '/Lead/:uuid',
    name: 'Lead',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Lead.vue')
  },
  {
    path: '/pipeline-report',
    name: 'PipelineReport',
    component: PipelineReports
  },
    {
    path: '/leads/for/:itemType',
    name: 'pipeline-Leads-List',
    component: () => import(/* webpackChunkName: "LeadsListpipeline" */ '../views/LeadsList.vue')
  },
  {
    path: '/lead-ageing-report',
    name: 'LeadAgeingReports',
    component: LeadAgeingReport
  },
  {
    path: '/LeadAgeingDetails',
    name: 'LeadAgeingDetails',
    component: () => import(/* webpackChunkName: "LeadAgeingDetails" */ '../views/LeadAgeingReport/LeadAgeingDetails.vue')
  },
  {
    path: '/marketing-campaign-report',
    name: 'MarketingCampaignReport',
    component: () => import(/* webpackChunkName: "MarketingCampaignReport" */ '../views/MarketingCampaign/MarketingCampaignReport.vue')
  },
  {
    path: '/marketing-campaign-details',
    name: 'MarketingCampaignDetails',
    component: () => import(/* webpackChunkName: "MarketingCampaignDetails" */ '../views/MarketingCampaign/MarketingCampaignDetails.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
